// extracted by mini-css-extract-plugin
module.exports = {"darkBackground":"Section_darkBackground__3eFS5","backLink":"Section_backLink___kpDC"};